import { inject, Injectable } from '@angular/core';
import { EclassWorkerEnum } from '@app/core/models/eclass-worker.enum';
import { ModalAssessmentExecutionService } from '@app/modules/assessments-manager/shared/modal-assessment-execution/modal-assessment-execution.service';
import { safeDate } from '@app/shared/utils';
import { endOfYear, isAfter, isBefore, startOfYear, subDays, subYears } from 'date-fns';
import { isEqual, sortBy } from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export const INTERVAL_FILTER = 1;

@Injectable({ providedIn: 'root' })
export class FilterService {
  public readonly today = new Date();
  public readonly maxDate = endOfYear(new Date());
  public readonly minDate = startOfYear(subYears(new Date(), 1));
  private readonly _queryParams$ = new BehaviorSubject(null);
  private readonly _academicYear$ = new BehaviorSubject<boolean>(false);
  public readonly _sidenav$ = new BehaviorSubject(null);
  public queryParams$: Observable<any>;
  public academicYear$: Observable<boolean>;
  public readonly filter$: Observable<any>;
  public readonly refresh$: Observable<number>;
  private readonly _refresh$ = new Subject<number>();
  private readonly _modalAssessmentExecutionService = inject(ModalAssessmentExecutionService);

  constructor() {
    this.refresh$ = this._refresh$.asObservable();
    this.queryParams$ = this._queryParams$.asObservable();
    this.academicYear$ = this._academicYear$.asObservable();
    this.filter$ = this._sidenav$.pipe(distinctUntilChanged(isEqual));
    this._modalAssessmentExecutionService.refresh$.subscribe(() => this.refresh());
  }

  public refresh() {
    this._refresh$.next(Date.now());
  }

  public sidenav(fn: (value: any) => any) {
    this._sidenav$.next(fn(this._sidenav$.value) || {});
  }

  public init(params: any) {
    this._queryParams$.next(params);
    this._sidenav$.next(null);
  }

  public updateQueryParams(params: any) {
    this._queryParams$.next({ ...this._queryParams$.value, ...params });
  }

  public loadSidenav(params: any) {
    const [min, max] = this.safeDate(params);
    const worker = EclassWorkerEnum;
    return {
      date_min: min,
      date_max: max,
      worker_id: params.worker_id && worker[params.worker_id] ? Number(params.worker_id) : worker.All,
    };
  }

  private safeDate({ date_min, date_max }: any): Date[] {
    const max = safeDate(date_max) || this.today;
    const min = safeDate(date_min) || subDays(max, 15);

    const safeMin = isBefore(min, this.minDate) ? this.minDate : min;
    const safeMax = isAfter(max, this.maxDate) ? this.maxDate : max;
    return sortBy([safeMin, safeMax]);
  }
}
